import { INITIAL_FACET_OVERRIDES } from '@/pages/Search/SearchPage/types';
import { SearchExclusionSlice } from '@/redux/modules/search/exclusions/searchExclusions.types';
import { AugmentedSearchQuery, AugmentedSearchQueryOptions, SearchQuery } from '@/types/search/searchQuery';
import { SearchCompletedTrigger } from '@/utils/amplitude/analytics/core.types';

export const getAugmentedSearchQuery = (
    searchQuery: SearchQuery,
    searchExclusions: SearchExclusionSlice['excludedFacets']
): AugmentedSearchQuery => {
    const augmentedOptions: AugmentedSearchQueryOptions = Object.keys(searchExclusions).reduce(
        (options, facetWithExclusions) => ({
            ...options,
            [facetWithExclusions]: [
                {
                    exclude: searchExclusions[facetWithExclusions] || [],
                    include: searchQuery.options[facetWithExclusions] || [],
                },
            ],
        }),
        {
            ...searchQuery.options,
            auctionHouse: [{ exclude: [], include: [] }],
        }
    );
    const augmentedSearchQuery: AugmentedSearchQuery = {
        ...searchQuery,
        // INITIAL_FACET_OVERRIDES first so any caller-supplied facetOverrides
        // win on the same key -- View More refetches via
        // `refetchWithFacetOverrides` carry their own size=100/500 for the
        // expanded facet and must override the initial size=6/7.
        facetOverrides: { ...INITIAL_FACET_OVERRIDES, ...searchQuery.facetOverrides },
        options: augmentedOptions,
    };

    augmentedSearchQuery.topRated = augmentedSearchQuery.options.topRated;

    return augmentedSearchQuery;
};

export function getSearchCompletedTrigger(
    trigger: string | undefined,
    searchSuggestionUsed: boolean,
    submittedFromSearchBar: boolean
): SearchCompletedTrigger {
    if (trigger === 'upcoming-items') {
        return SearchCompletedTrigger.UpcomingItems;
    }
    if (searchSuggestionUsed || submittedFromSearchBar) {
        return SearchCompletedTrigger.SearchBar;
    }
    return SearchCompletedTrigger.Other;
}
